import { Injectable } from '@angular/core';
import { AuthService } from '../../../core/auth.service';
import { StorageService } from '../../../core/storage/storageService';
import { User } from '../../../models/users/user';

@Injectable({
  providedIn: 'root',
})
export class AccessManager {

  // TODO: remove:
  static AUTH_MERCHANT_NAV: string = 'portal.admin.merchant.nav'; 
  static AUTH_INSERT_BUSINESSES: string = 'portal.businesses-c';
  static AUTH_BUSINESSES_NS: string = 'portal.businesses';
  static AUTH_SELECT_CUSTOMERS: string =      'portal.merchant.customers-r';
  static AUTH_INSERT_CUSTOMERS: string =      'portal.merchant.customers-c';
  static AUTH_UPDATE_MERCHANT_CONTACT: string = 'portal.merchant.contact-w';
  static AUTH_SELECT_MERCHANT_SETTINGS: string = 'portal.merchant.settings-r';
  static AUTH_UPDATE_MERCHANT_SETTINGS: string = 'portal.merchant.settings-w';
  static AUTH_SELECT_MERCHANT_ACCOUNT: string = 'portal.merchant-r';
  static AUTH_UPDATE_MERCHANT_ACCOUNT: string = 'portal.merchant-w';
  static AUTH_SELECT_MERCHANTS: string = 'portal.merchants-r';
  static AUTH_MERCHANT_ACCOUNT_NS: string = 'portal.merchants.account'; // ???
  static AUTH_GLOBAL_SEARCH: string =                 'portal.search-r';

  ////////////////


  static AUTH_VIEW_INVOICES: string =                 'portal.merchant.invoices-r';
  static AUTH_CREATE_INVOICES: string =               'portal.merchant.invoices-w';

  static AUTH_VIEW_ADMIN: string =                    'portal.admin'; // TODO: rename to portal.admin
  static AUTH_SELECT_MERCHANT_GROUPS: string =        'portal.admin.merchant-groups-r';
  static AUTH_UPDATE_MERCHANT_GROUPS: string =        'portal.admin.merchant-groups-w';
  static AUTH_SELECT_MERCHANT_BRANDS: string =        'portal.admin.merchant-brands-r';
  static AUTH_UPDATE_MERCHANT_BRANDS: string =        'portal.admin.merchant-brands-w';
  static AUTH_SELECT_ROLES: string =                  'portal.admin.roles-r';
  static AUTH_UPDATE_ROLES: string =                  'portal.admin.roles-w';
  static AUTH_INSERT_ALL_USERS: string =              'portal.admin.users.all-c';

  static AUTH_SELECT_ALL_BUSINESSES: string =         'portal.businesses.all-r';
  static AUTH_UPDATE_ALL_BUSINESSES: string =         'portal.businesses.all-w';
  static AUTH_SELECT_BUSINESSES: string =             'portal.businesses-r';
  static AUTH_UPDATE_BUSINESSES: string =             'portal.businesses-w';
  static AUTH_INSERT_BUSINESS_USER: string =          'portal.businesses.users-c';

  static AUTH_SELECT_ALL_CUSTOMERS: string =          'portal.customers.all-r';
  static AUTH_UPDATE_ALL_CUSTOMERS: string =          'portal.customers.all-w';

  static AUTH_DASHBOARD_MYMERCHANTS: string =         'portal.dashboard.my-mids';
  static AUTH_DASHBOARD_METRICS: string =             'portal.dashboard.mid-metrics';
  static AUTH_DASHBOARD_FAVORITES: string =           'portal.dashboard.favorites';
  static AUTH_DASHBOARD_GLOBAL_SEARCH: string =       'portal.dashboard.global-search';
  static AUTH_DASHBOARD_MYBUSINESSES: string =        'portal.dashboard.my-businesses';
  static AUTH_DASHBOARD_MYTRANSACTIONS: string =      'portal.dashboard.my-transactions';

  static AUTH_SELECT_MERCHANT_BILLING: string =       'portal.merchant.billing-r';
  static AUTH_UPDATE_MERCHANT_BILLING: string =       'portal.merchant.billing-w';
  static AUTH_SELECT_MERCHANT_CATALOGS: string =      'portal.merchant.catalogs-r';
  static AUTH_UPDATE_MERCHANT_CATALOGS: string =      'portal.merchant.catalogs-w';
  static AUTH_CREATE_MERCHANT_CATALOGS: string =      'portal.merchant.catalogs-c';
  static AUTH_SELECT_MERCHANT_CONTACTS: string =      'portal.merchant.contacts-r';
  static AUTH_UPDATE_MERCHANT_CONTACTS: string =      'portal.merchant.contacts-w';
  static AUTH_SELECT_MERCHANT_CUSTOMERS: string =     'portal.merchant.customers-r';
  static AUTH_UPDATE_MERCHANT_CUSTOMERS: string =     'portal.merchant.customers-w';
  static AUTH_SELECT_MERCHANT_INFO: string =          'portal.merchant.businessinfo-r';
  static AUTH_UPDATE_MERCHANT_INFO: string =          'portal.merchant.businessinfo-w';
  static AUTH_SELECT_MERCHANT_ORDERS: string =        'portal.merchant.orders-r';
  static AUTH_SELECT_MERCHANT_PROCESSORS: string =    'portal.merchant.processors-r';
  static AUTH_UPDATE_MERCHANT_PROCESSORS: string =    'portal.merchant.processors-w';
  static AUTH_INSERT_MERCHANT_TRANSACTIONS: string =  'portal.merchant.transactions-w';
  static AUTH_SELECT_MERCHANT_TRANSACTIONS: string =  'portal.merchant.transactions-r';

  static AUTH_SELECT_MERCHANT_USERS: string =         'portal.merchant.users-r';
  static AUTH_UPDATE_MERCHANT_USERS: string =         'portal.merchant.users-w';
//  static AUTH_ACCESS_TERMINAL: string =               'portal.merchant.terminal';

  static AUTH_INSERT_MERCHANTS: string =              'portal.merchants-c';
  static AUTH_SELECT_ALL_MERCHANTS: string =          'portal.merchants.all-r';
  static AUTH_UPDATE_ALL_MERCHANTS: string =          'portal.merchants.all-w';

  static AUTH_MANAGE_SITEDATA: string =               'portal.manage.sitedata-w';

  static AUTH_SELECT_ALL_TRANSACTIONS: string =       'portal.transactions.all-r';
  static AUTH_MANAGE_ALL_TRANSACTIONS: string =       'portal.transactions.all-w';

  static AUTH_SELECT_ALL_USERS: string =              'portal.admin.users-r';
  static AUTH_MANAGE_ALL_USERS: string =              'portal.admin.users-w';
  static AUTH_IMPERSONATE_USER: string =              'portal.users.impersonate';

  constructor(
    private auth: AuthService,
    private storage: StorageService,
  ) {}

  public async getUserAccess(
    namespace: string | string[],
  ): Promise<Record<string, boolean>> {
    let usr = this.storage.getCurrentUser();

    if (usr == undefined) {
      throw 'no current user';
    }
    return await this.auth.checkAccess(namespace)
  }
}
